import { Link } from "react-router-dom";
import { useEffect } from "react";
import DefaultButton from "../components/buttons/DefaultButton";
import Logo from "../components/Logo";
import { NotificationButton } from "../components/NotificationButton";
import { NotificationsChecker } from "../components/NotificationsChecker";
import { SettingsButton } from "../components/SettingsButton";

function Home() {
  useEffect(() => {
    // Redirect Comando role to /admin/reservations
    const roleName = localStorage.getItem("roleName");
    if (roleName === "Comando") {
      window.location.href = "/admin/reservations";
    }
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("authToken");
    localStorage.removeItem("name");
    localStorage.removeItem("username");
    localStorage.removeItem("isMaster");
    localStorage.removeItem("roleName");
    localStorage.removeItem("roleType");
  };

  return (
    <div className="container vh-100 d-flex flex-column justify-content-between align-items-center">
      <NotificationsChecker />
      <div className="text-center pt-5 w-100">
        <Logo />

        <div className="px-4">
          <div className="row">
            <div className="col-12 mb-4 fw-bold">
              Bem-vindo(a) {localStorage.getItem("name")}
            </div>

            <div className="col-6 d-flex justify-content-center ">
              <Link to="/confirm">
                <div
                  className="p-3 border border-2 rounded-4 border-secondary square d-flex justify-content-center align-items-center fw-bold cursor-pointer"
                  style={{ width: "150px" }}
                >
                  <div>
                    Nova
                    <br />
                    Reserva
                  </div>
                </div>
              </Link>
            </div>

            <div className="col-6 d-flex justify-content-center ">
              <Link to="/my-reservations">
                <div
                  className="p-3 border border-2 rounded-4 border-secondary square d-flex justify-content-center align-items-center fw-bold cursor-pointer"
                  style={{ width: "150px" }}
                >
                  <div>
                    Minhas <br />
                    Reservas
                  </div>
                </div>
              </Link>
            </div>

            <div className="col-6 d-flex justify-content-center mt-4">
              <Link to="/reservation-history">
                <div
                  className="p-3 border border-2 rounded-4 border-secondary square d-flex justify-content-center align-items-center fw-bold cursor-pointer"
                  style={{ width: "150px" }}
                >
                  <div>
                    Reservas <br />
                    Antigas
                  </div>
                </div>
              </Link>
            </div>

            <div className="col-6 d-flex justify-content-center mt-4">
              <Link to="/checkin">
                <div
                  className="p-3 border border-2 rounded-4 border-secondary square d-flex justify-content-center align-items-center fw-bold cursor-pointer"
                  style={{ width: "150px" }}
                >
                  <div>Checkin</div>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="w-100 px-5 pb-5">
        <div>
          <DefaultButton route="/login" useHref={true} onClick={handleLogout}>
            Sair
          </DefaultButton>
        </div>
      </div>

      <NotificationButton />
      <SettingsButton />
    </div>
  );
}

export default Home;
